define({
  SUGGESTED: 'Suggested'
})
